/**
 * Kiosk 動畫小工具：飛入購物車的瓦斯桶 chip、彩帶。
 * 直接操作 DOM（App 跑在 web），移植自 proto5.html flyToCart / fireConfetti。
 */

const CYLINDER_SVG = `<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#2196f3" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M7 7a5 2.5 0 0 1 10 0v10a5 2.5 0 0 1-10 0Z"/><path d="M7 7a5 2.5 0 0 0 10 0"/><path d="M10 4.7V3.2a2 .7 0 0 1 4 0v1.5"/></svg>`;

/** 從畫面中央飛向購物車橫條（以 #kioskCartBar 為目標）。done 在動畫結束後呼叫。 */
export function flyToCart(done?: () => void) {
  const target = document.getElementById("kioskCartBar")?.getBoundingClientRect();
  const fly = document.createElement("div");
  fly.className = "kiosk-fly";
  fly.innerHTML = CYLINDER_SVG;
  fly.style.left = `${window.innerWidth / 2 - 28}px`;
  fly.style.top = `${window.innerHeight * 0.4}px`;
  document.body.appendChild(fly);
  requestAnimationFrame(() => {
    if (target) {
      fly.style.left = `${target.left + 30}px`;
      fly.style.top = `${target.top + 8}px`;
    } else {
      fly.style.top = `${window.innerHeight - 40}px`;
    }
    fly.style.transform = "scale(.3)";
    fly.style.opacity = "0.3";
  });
  if (navigator.vibrate) navigator.vibrate([15, 40, 15]);
  setTimeout(() => {
    fly.remove();
    done?.();
  }, 620);
}

/** 在指定容器內噴彩帶（成功頁）。 */
export function fireConfetti(parent: HTMLElement) {
  const colors = ["#2196f3", "#16a34a", "#ffc217", "#ff5d8f", "#7c5cff", "#ff8a3d"];
  for (let i = 0; i < 26; i++) {
    const c = document.createElement("div");
    c.className = "kiosk-confetti";
    c.style.background = colors[i % colors.length];
    c.style.left = `${40 + Math.random() * 20}%`;
    parent.appendChild(c);
    const dx = (Math.random() - 0.5) * 290;
    const dy = -140 - Math.random() * 180;
    const rot = Math.random() * 720;
    c.animate(
      [
        { transform: "translate(0,0) rotate(0)", opacity: 1 },
        { transform: `translate(${dx}px,${dy}px) rotate(${rot}deg)`, opacity: 0 },
      ],
      { duration: 1000 + Math.random() * 500, easing: "cubic-bezier(.2,.7,.3,1)" },
    );
    setTimeout(() => c.remove(), 1550);
  }
}
